import { render } from "./DigitalTriplet.vue?vue&type=template&id=6974d7a1&scoped=true"
import script from "./DigitalTriplet.vue?vue&type=script&lang=js"
export * from "./DigitalTriplet.vue?vue&type=script&lang=js"

import "./DigitalTriplet.vue?vue&type=style&index=0&id=6974d7a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6974d7a1"]])

export default __exports__